<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="d-flex flex-column">
        <div class="text-right mb-3"></div>
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Record Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>

      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <template #cell(index)="row">
              <span> {{ row.index + 1 }} </span>
            </template>

            <template v-slot:cell(denominazioneStruttura)="{ item }">
              <span>({{ item.codiceStruttura }}) {{ item.denominazioneStruttura }} </span>
            </template>

            <template v-slot:cell(actions)="row">
              <b-container class="bv-example-row">
                <b-button size="sm" v-b-tooltip.hover title="Modifica Tipo Documento" variant="outline-success" @click="onClickEditTipoDocumento(row.item)">
                  <font-awesome-icon icon="edit"> </font-awesome-icon>
                </b-button>
                <b-button size="sm" v-b-tooltip.hover title="Cancella Tipo Documento" variant="outline-danger" @click="onClickEliminaTipoDocumento(row.item)" class="mr-1 no-text">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
      </div>
      <div class="sa-list-component-footer">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
    <configurazione-contabilita-tipo-documenti-edit-modal-component
      ref="mdlConfigurazioneContabilitaTipoDocumentiEditModalComponent"
      @beforeSave="onBeforeSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent"
      @afterSave="onAfterSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent"
    ></configurazione-contabilita-tipo-documenti-edit-modal-component>
    <sa-modal-loading ref="saModalLoading" />
  </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioneContabilitaTipoDocumentiEditModalComponent from "./ConfigurazioneContabilitaTipoDocumentiEditModalComponent.vue";
import { SaModalLoading } from "../../../template/components/modal";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  components: { ConfigurazioneContabilitaTipoDocumentiEditModalComponent, SaModalLoading },
  mixins: [UtilityMixin],
  data() {
    return {
      rows: 0,
      perPage: 50,
      currentPage: 1,
      pathResource: "/contabilitadocumentotipo",
      showModalLoading: false,
      listKey: 0,
      filtro: {},
      items: [],
      fields: [
        {
          label: "*",
          key: "index",
          thStyle: "width: 4rem",
        },
        {
          label: "Codice",
          key: "codiceTipoDocumento",
          sortable: true,
          thStyle: "width: 8rem",
        },
        {
          label: "Struttura",
          key: "denominazioneStruttura",
          sortable: true,
        },

        {
          label: "Descrizione",
          key: "descrizioneTipoDocumento",
          sortable: true,
        },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
    };
  },
  mounted() {
    let me = this;
    me.loadData();
  },
  methods: {
    loadData() {
      let me = this;
      me.openShowModalLoading();
      me.$emit("beforeLoadData");
      let sessionStorage = window.sessionStorage;
      if (sessionStorage["filtroTipiDocumento"]) {
        me.filtro = JSON.parse(sessionStorage["filtroTipiDocumento"]);
        me.$emit("updateFilter", me.filtro);
      }
      me.filtro.page = me.currentPage;
      me.filtro.forPage = me.perPage;
      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.closeShowModalLoading();
      me.$emit("afterLoadData");
    },
    loadDataError(error) {
      let me = this;
      console.error("Errore durante il caricamento dei dati:", error);
      me.items = [];
      me.rows = 0;
      me.closeShowModalLoading();
      me.$emit("afterLoadData");
    },
    onClickEditTipoDocumento(item) {
      let me = this;
      me.$refs.mdlConfigurazioneContabilitaTipoDocumentiEditModalComponent.show(item);
    },
    onBeforeSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent() {
      //this.$refs.saModalLoading.show();
      //this.$refs.globalModalLoading.open();
    },
    onAfterSaveMdlConfigurazioneContabilitaTipoDocumentiEditModalComponent() {
      console.log("loadData");

      this.loadData();
    },
    onClickEliminaTipoDocumento(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di voler eliminare questo tipo documento ?", {
          title: "Eliminazione Tipo Documento",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.eliminaTipoDocumento(item.id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    eliminaTipoDocumento(id) {
      UtilityMixin.methods.deleteResource(this.pathResource + "/" + id, this.onEliminaTipoDocumentoSuccess, this.onEliminaTipoDocumentoError);
    },
    onEliminaTipoDocumentoSuccess(response) {
      response;
      this.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });

      this.loadData();
    },
    onEliminaTipoDocumentoError(error) {
      error;
      this.loadData();
    },
  },
};
</script>

<style></style>
